<template>
    <div class="page_index">
        <div
            class="scroll_ist"
            :style="itemStyle"
        >
            <vue-seamless-scroll
                class="scoll_warp"
                :data="rankList"
                :class-option="{ ...scrollOption }"
                :style="{height:scrollItemHeight}"
            >
                <ul>
                    <li
                        v-for="(item,index) in rankList"
                        :key="index"
                        :style="isLeft(index)"
                    >
                        <div class="flex flex_sb page_list">
                            <div>{{item.name}}</div>
                            <!-- <div
                                class="page_border"
                                :style="borderStyle"
                            ></div> -->
                            <div>
                                <div class="flex">
                                    <div class="page_price">{{item.price}}{{item.expenditureUnit}}{{item.unitName ? '元/' : ''}}</div>
                                    <div v-if="item.unitName">{{item.unitName}}</div>
                                </div>
                            </div>
                            <div
                                v-if="isShow"
                                class="page_title"
                            >{{item.supplierName}}</div>
                        </div>
                        <!-- 数组的最后一条不显示边框线 -->
                        <!-- {{isShow && index === rankList.length -1}} -->
                        <!-- <div :class="(!isShow || index === rankList.length -1) ? '' : 'page_line'"></div> -->
                        <!-- <div class="page_line"></div> -->
                    </li>

                </ul>
            </vue-seamless-scroll>
        </div>
    </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import { fontVh, keepTwoDecimalFull } from "@/assets/js/common";
export default {
    name: 'itemList',
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        rankList: {
            type: Array,
            default: () => []
        },
        unit: {
            type: String,
            default: ''
        },
        uniIdx: {
            type: [ Number, String ],
            default: 1
        },
        // 用于改变数组列表单独一列文字靠左对齐
        active: {
            type: Number,
            default: -1
        },
        scrollHeight: {
            type: String,
            default: ''
        },
        scrollItemHeight: {
            type: String,
            default: ''
        },
        isStep: { // 是否滚动
            type: Boolean,
            default: false
        },
        borderWidth: {
            type: Number,
            default: 150
        }
    },
    data() {
        return {}
    },
    watch: {
        rankList: {
            handler(newValue) {
                if (newValue.length > 0) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (newValue[i].price && newValue[i].price !== '--') {
                            newValue[i].price = keepTwoDecimalFull(Number(newValue[i].price))
                        }
                    }
                }

            }
        }
    },
    components: {
        vueSeamlessScroll
    },
    created() { },
    computed: {
        scrollOption() {
            const { isStep } = this
            const options = {
                step: isStep ? 0.8 : 0, // 数值越大速度滚动越快
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 1 // 0向下 1向上 2向左 3向右
            }
            options.limitMoveNum = isStep ? this.rankList.length / 2 : 100 // 开始无缝滚动的数据量
            return options
        },
        itemStyle() {
            const { scrollHeight } = this
            return `height:${fontVh(scrollHeight)};`
        },
        isLeft() {
            return (idx) => {
                return `text-align:${this.active != idx ? 'center' : 'left'};`
            }
        },
        borderStyle() {
            const { borderWidth } = this
            return `width:${fontVh(borderWidth)};`
        }
    },
    methods: {}
}
</script>

<style lang='scss' scoped>
.page_index {
    word-break: break-all;
    overflow: hidden;
    .page_list {
        width: 100%;
        border-bottom: 1px solid #F0C0A3;
        padding: 0 vh(20) vh(12);
        .page_price {
            @include font(24, #A84E14);
            font-weight: bold;
        }
    }

    .scroll_ist {
        overflow: hidden;

        .scroll_header {
            margin: vh(8) 0 vh(14) 0;
            @include flex();
            @include font(16, $list_color, center);
            > div {
                position: relative;
                padding: 0 vh(10);
            }
        }
        .scoll_warp {
            overflow: hidden;
            ul {
                li {
                    @include font(24, #A84E14, center);
                    font-weight: bold;
                    height: vh(50);
                    span {
                        padding: 0 vh(10);
                        word-break: break-all;
                    }
                    div {
                        text-align: left;
                        justify-content: space-between;
                    }
                    .page_border {
                        margin: 0 vh(10);
                        border: vh(1) dashed #A84E14;
                    }
                    .page_title {
                        margin-top: vh(10);
                        height: vh(58);
                    }
                }
            }
        }
        .page_line {
            width: 98%;
            height: vh(1);
            margin: vh(10) auto;
            background: linear-gradient(
                to right,
                #00048f 0%,
                #00048f 10%,
                #00558b 20%,
                #00558b 30%,
                #00558b 40%,
                #00558b 50%,
                #00558b 60%,
                #00558b 70%,
                #00558b 80%,
                #00048f 90%,
                #00048f 100%
            );
        }
    }
}
</style>
